import { GET_SUPERVISOR_GROUPS, CREATE_NEW_SUPERVISOR_GROUP, DELETE_SUP_GROUP } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import { parseResponse } from '@jweb-development/response-parser'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getSupervisorGroups = (fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const { token, accountId } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/groups`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data: supervisorGroups = [] } = await response.json()

        dispatch({
          type: GET_SUPERVISOR_GROUPS,
          payload: supervisorGroups
        })
      } else {
        log.warn('non 200 status code from supervisor groups')
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const createNewSupGroup = (info, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...info }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/groups`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
      return false
    } else {
      fireSuccess()
      dispatch({
        type: CREATE_NEW_SUPERVISOR_GROUP,
        payload: { ...body }
      })
      return true
    }
  }
}

export const updateGroup = (groupID, info, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const accountID = accountId

    const body = { ...info }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/supervisors/groups/${groupID}`, options))
    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
    }
  }
}

export const deleteGroup = (groupID, fireDeleteSuccess, fireDeleteFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const responseDel = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/groups/${groupID}`, options))

    if (!responseDel.status || responseDel.status === 401 || responseDel.status === 404 || responseDel.status === 500) {
      fireDeleteFailure()
    } else {
      fireDeleteSuccess()
      dispatch({
        type: DELETE_SUP_GROUP,
        payload: {}
      })
    }
  }
}
